module.exports = __webpack_public_path__ + "static/media/dots-vertical.24007e5b.svg";